import { render, staticRenderFns } from "./Bibliotheque.vue?vue&type=template&id=7bd7c7c9"
import script from "./Bibliotheque.vue?vue&type=script&lang=js"
export * from "./Bibliotheque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports